
import React from 'react';
import Competitor360View from '../components/competitor_360/Competitor360View';

const Competitor360 = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Competitor360View />
    </div>
  );
};

export default Competitor360;
